import { isShareableLandingPath, Paths, SEARCH_PARAMS, STORAGE_KEY } from "@constants";
import { generatePath } from "react-router-dom";

export function buildMemberReferralAbsoluteUrl(
  refCode: string | undefined | null,
  destination?: string | null,
): string {
  const siteUrl = `${window.location.protocol}//${window.location.host}`;
  const code = refCode?.trim() || "????";
  const url = siteUrl + generatePath(Paths.PUBLIC.REFERRAL_CALLBACK, { refCode: code });
  if (isShareableLandingPath(destination)) {
    const params = new URLSearchParams();
    params.set(SEARCH_PARAMS.NEXT, destination);
    return `${url}?${params.toString()}`;
  }
  return url;
}

export const storeReferralCode = (refCode: string | undefined | null) => {
  if (refCode) {
    sessionStorage.setItem(STORAGE_KEY.REF_CODE, refCode);
  }
};

export const getReferralCode = () => {
  return sessionStorage.getItem(STORAGE_KEY.REF_CODE) || undefined;
};

export const clearReferralCode = () => {
  sessionStorage.removeItem(STORAGE_KEY.REF_CODE);
};
